import { asyncLoad } from '@util'

export default {
  path: 'purchaseHistory',
  indexRoute: {
    component: asyncLoad(() =>
      import('@components/LocalMerchant/PurchaseHistory')
    )
  },
  stat: '购买记录',
  childRoutes: [
    {
      path: 'detail',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/PurchaseHistory/PaymentDetail')
      ),
      stat: '购买记录/订单详情'
    }
  ]
}
